module.exports = __webpack_public_path__ + "static/img/map_anhui.c86ecd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/join/map_anhui.png
// module id = aBMp
// module chunks = 0